// directives/imageLazyLoad.js
// utils/lazyLoad.js
export const imageLazyLoad = {
  mounted(el) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src;
          
          // 图片加载完成后添加 loaded 类
          img.onload = () => {
            img.classList.add('loaded');
          };
          
          img.removeAttribute('data-src');
          observer.unobserve(img);
        }
      });
    }, { rootMargin: '100px' });

    el.querySelectorAll('img[data-src]').forEach(img => observer.observe(img));
  }
};